import { render, staticRenderFns } from "./eventSwiper.vue?vue&type=template&id=437d7d2a&scoped=true&"
import script from "./eventSwiper.vue?vue&type=script&lang=js&"
export * from "./eventSwiper.vue?vue&type=script&lang=js&"
import style0 from "./eventSwiper.vue?vue&type=style&index=0&id=437d7d2a&lang=sass&scoped=true&"
import style1 from "./eventSwiper.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d7d2a",
  null
  
)

export default component.exports